var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-vcenter ml-5"},[_c('img',{staticClass:"mr-5 has-opacity-6",attrs:{"src":require(`@/assets/icons/not-assigned/${_vm.type}.svg`)}}),_c('span',{staticClass:"is-regular-14-00-17 has-opacity-6 no-whitespace-wrap"},[_vm._v(_vm._s(_vm.typeText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }